import { all, put, takeLatest } from 'redux-saga/effects';
import API_ENDPOINTS from '../../../config/API-endpoints';
import { getCookie } from '../../../utils';
import { fetcherAction } from '../fetcher/creator';
import {
  candidateOverviewActions,
  candidateOverviewConstants,
} from './creator';

const candidateAPI = {
  getCandidateDetails: (candidateId) => ({
      tokenize: true,
      fetcherParams: {
        method: 'GET',
        url: API_ENDPOINTS.candidateDetails(candidateId),
      },
      headers: {
        authorization: getCookie('authToken'),
        'Content-Type': 'application/json',
      },
    }),
};

// eslint-disable-next-line require-yield
function* handleLocationChange({ payload }) {
  return payload;
}

function* fetchCandidateDetails({ payload }) {
  return yield put(fetcherAction({
    ...candidateAPI.getCandidateDetails(payload),
    label: candidateOverviewConstants.FETCH_CANDIDATE_DETAILS,
  }));
}

function* fetchCandidateDetailsOnSuccess({ response }) {
  return yield put(candidateOverviewActions.setCandidateData(response));
}

export default function* candidateOverviewSagas() {
  yield all([
    // to use below pattern, 'connected-react-router' is required in dependencies.
    takeLatest('@@router/LOCATION_CHANGE', handleLocationChange),


    takeLatest(candidateOverviewConstants.FETCH_CANDIDATE_DETAILS.TRIGGER, fetchCandidateDetails),
    takeLatest(
candidateOverviewConstants.FETCH_CANDIDATE_DETAILS.SUCCESS,
      fetchCandidateDetailsOnSuccess,
      ),
  ]);
}
